import { AbstractControl, ValidationErrors, ValidatorFn, FormArray } from '@angular/forms';

export function mustSelectOne(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const formArray = control as FormArray;
    type PartialShape = {
      active: boolean;
    };

    if (formArray.value.some(({ active }: PartialShape) => active)) {
      return null;
    }

    return {
      description: 'Debe seleccionar al menos un elemento de la lista',
      code: '300',
    };
  };
}


export function mustSelectOneThatIsNotDisabled(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const formArray = control as FormArray;
    type PartialShape = {
      active: boolean;
      disabled: boolean;
    };

    if (formArray.value.some(({ active, disabled }: PartialShape) => active && !disabled)) {
      return null;
    }

    return {
      description: 'Debe seleccionar al menos un elemento de la lista',
      code: '300',
    };
  };
}
